import { render, staticRenderFns } from "./SetProductsSection.vue?vue&type=template&id=4ec2a4a8&scoped=true&lang=pug&"
import script from "./SetProductsSection.vue?vue&type=script&lang=js&"
export * from "./SetProductsSection.vue?vue&type=script&lang=js&"
import style0 from "./SetProductsSection.vue?vue&type=style&index=0&id=4ec2a4a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec2a4a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ec2a4a8')) {
      api.createRecord('4ec2a4a8', component.options)
    } else {
      api.reload('4ec2a4a8', component.options)
    }
    module.hot.accept("./SetProductsSection.vue?vue&type=template&id=4ec2a4a8&scoped=true&lang=pug&", function () {
      api.rerender('4ec2a4a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/SetProductsSection.vue"
export default component.exports